// extracted by mini-css-extract-plugin
export default {"r_l":"a6805d2fd7 dcec5cd2d1","t":"cbe502e94e"};